import styled from "styled-components";

const METHOD_COLORS: Record<string, string> = {
  get: "#1976d2",
  post: "#2e7d32",
  put: "#ed6c02",
  patch: "#9c27b0",
  delete: "#d32f2f",
};

export const LogsWrapper = styled.div`
  margin-top: 36px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const SectionTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
`;

export const Wrapper = styled.div`
  padding: 16px;
  background: #f8f9fa;
  border-radius: 12px;
  border: 1px solid #e0e0e0;
`;

export const Inner = styled.div`
  padding: 4px 0;
  word-break: break-all;
  font-family: "Roboto Mono", monospace;
  font-size: 13px;
  line-height: 1.6;
  color: #333;

  strong {
    color: #1976d2;
    font-weight: 600;
  }
`;

export const RouteInfoGrid = styled.div`
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  margin-top: 24px;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 12px;
  border: 1px solid #e0e0e0;
`;

export const RouteInfoItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const RouteInfoLabel = styled.span`
  font-size: 12px;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const RouteInfoValue = styled.span`
  font-size: 15px;
  font-weight: 500;
  color: #333;
  font-family: "Roboto Mono", monospace;
`;

export const MethodBadge = styled.span<{ method?: string }>`
  display: inline-block;
  padding: 2px 12px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 700;
  font-family: "Roboto Mono", monospace;
  color: white;
  background: ${({ method }) =>
    METHOD_COLORS[method?.toLowerCase() ?? ""] ?? "#757575"};
`;
